/*


START bottom.js
____________________________




*/


// Remove #JSnote for JavaScript users
$('#JSnote').remove();


function removeMicroNote(event) {
    event.target.parentNode.removeChild(event.target);
}

document.getElementById('MicroNote').addEventListener('click', removeMicroNote);

if (!(document.documentMode || /Edge/.test(navigator.userAgent))) {
    document.getElementById('mainContent').removeChild(document.getElementById('MicroNote'));


}


/*


END bottom.js
____________________________



*/


//Build Switch to show/hide nerf war
$('#nerfViewSwitch').click(function () {
    var burstMax = 250;
    var burstMin = 100;
    currentDartMax = usedMax = burstMax;
    currentDartMin = usedMin = burstMin;
    var targetElements = [$('#mainContent>*:not(:first-child):not(#whiteSpace2)'), $('.filter.all'), $('#whiteSpace2')];
    var nerfViewSwitch = $('#nerfViewSwitch>span').text();
    if (nerfViewSwitch === 'Show ') {

        TweenMax.to(targetElements, 1, {
            opacity: 0, onComplete: function () {
                targetElements[2][0].style.visibility = 'hidden';
            }
        });
        $('#nerfViewSwitch>span').text('Hide ');
    } else {
        currentDartMax = usedMax = defaultMax;
        currentDartMin = usedMin = defaultMin;
        $(targetElements).css('visibility', 'visible');
        targetElements[2][0].style.visibility = 'visible';
        TweenLite.to(targetElements[1], 1, {opacity: 1});
        TweenLite.to(targetElements[0], 1, {opacity: 1});
        if (whiteSpace2Visible) {
            TweenLite.to(targetElements[2][0], 1, {opacity: 1});
        } else {
            TweenLite.to(targetElements[2][0], 1, {opacity: 0});
        }

        $('#nerfViewSwitch>span').text('Show ');
        //     clearInterval(burstTimer);
    }
});


$('footer>a[href="#contact"]').click(function (event) {
    event.preventDefault();

    TweenLite.to(window, 1, {scrollTo: {y: '#contact', offsetY: 100}});
});

$('.promo.party a').click(function (event) {
    event.preventDefault();

    TweenLite.to(window, 1, {scrollTo: {y: '#partyTable', offsetY: 100}});
});

$('.promo.airsoft a').click(function (event) {
    event.preventDefault();

    TweenLite.to(window, 1, {scrollTo: {y: '#monday', offsetY: 100}});

    document.getElementById('monday').dispatchEvent(new MouseEvent('click'));
});

TweenMax.to($('.promo'), 1, {backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.00) 0%, transparent 100%', repeat: -1, repeatDelay:1})


/*

ABANDONED SCRIPTS
____________________________



*/


/*






        Timeline player START
    ____________________________







    */


/*

TO REACTIVATE, PLACE 

{ onUpdate: slideSlider }

INTO THE ARGUMENTS OF THE TARGET ELEMENT
*/
/*


//var Name of the Timeline you want to watch
var targetTimeline = initialTween;
var stringOfTargetTimeLine = 'initialTween';
var sliderMax = 1000;



function displayCurrentTargetTimeline() {
    if (targetTimeline !== undefined) {
        $('#DisplayTargetTimeline').html('Target = ' + stringOfTargetTimeLine);
    }
}

function slideSlider() {
    if (targetTimeline !== undefined) {
        $("#testerSlider").slider("value", targetTimeline.progress() * sliderMax);
        updatePlayBackNumber();
    }
}

function updatePlayBackNumber() {
    $('#playBackTime').html(targetTimeline.time().toFixed(2));
}

$('#testerSlider').slider({
    range: false,
    min: 0,
    max: sliderMax,
    step: 1,
    slide: function(event, ui) {
        targetTimeline.pause();
        //change targeted timeline to match sliders value
        targetTimeline.progress(ui.value / sliderMax);
        updatePlayBackNumber();
    }
});

displayCurrentTargetTimeline();

$("#playButton").click(function() {
    targetTimeline.play();
});

$("#pauseButton").click(function() {
    targetTimeline.pause();
});

$("#reverseButton").click(function() {
    targetTimeline.reverse();
});

$("#resumeButton").click(function() {
    targetTimeline.resume();
});

$("#restartButton").click(function() {
    targetTimeline.restart();
});


*/